export const ETIQUETA_CATEGORIA: Record<string, string> = {
  residencial: 'Residencial',
  comercial: 'Comercial',
  industrial_artesanal: 'Industrial artesanal',
}

// En la cotizacion ESTANDAR un cliente 'industrial' cae en el pliego industrial artesanal
// (sin demanda). La tarifa con demanda y lo trifasico estan en la cotizacion industrial.
export const TARIFA_DE_CATEGORIA: Record<string, string> = {
  residencial: 'residencial',
  comercial: 'comercial',
  industrial: 'industrial_artesanal',
}
